import { render, staticRenderFns } from "./OccasionModal.vue?vue&type=template&id=7095afbb"
import script from "./OccasionModal.vue?vue&type=script&lang=js"
export * from "./OccasionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports